var map = {
	"./combo_grey.svg": "51d2",
	"./date_grey.svg": "1017",
	"./header_1_grey.svg": "0fafb",
	"./header_2_grey.svg": "1695",
	"./html_grey.svg": "fc40",
	"./image_grey.svg": "6876",
	"./list_grey.svg": "c367",
	"./text_grey.svg": "e635",
	"./youtube_grey.svg": "a330"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a076";